import React from "react";
import { TFunction } from "i18next";
import { Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";

import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import { onKeyboardActivate } from "@helpers/a11y";

import { AppDispatch } from "../../../../../../redux/store";
import {
    setIsActionsClicked,
    setIsEdited,
    setSortedVisibilityEdited,
} from "../../../../../../redux/slices/fidelitySlice";
import { useFidelityNavigationGuard } from "../../../FidelityNavigationGuardContext";

type Props = {
    row: FidelityRow;
    isEdited: boolean;
    isActionsClicked: boolean;
    setShopId: (id: FidelityRow["shopId"]) => void;
    setFidelity: (row: FidelityRow) => void;
    setIsAddFidelityClicked: (v: boolean) => void;
    setLocalFilterActive: (v: boolean) => void;
    setIsConsult: (v: boolean) => void;
    t: TFunction;
};

export default function ConsultIconButton({
    row,
    isEdited,
    isActionsClicked,
    setShopId,
    setFidelity,
    setIsAddFidelityClicked,
    setLocalFilterActive,
    setIsConsult,
    t,
}: Props) {
    const dispatch = useDispatch<AppDispatch>();
    const { setOnConfirm } = useFidelityNavigationGuard();
    const handleClick = () => {
        if (isEdited) {
            dispatch(setIsActionsClicked(!isActionsClicked));
            setOnConfirm(() => {
                dispatch(setIsEdited(false));
                setIsAddFidelityClicked(true);
                setShopId(row.shopId);
                setFidelity(row);
                setLocalFilterActive(false);
            });
        } else {
            setIsAddFidelityClicked(true);
            setFidelity(row);
            dispatch(setSortedVisibilityEdited(row.sortedVisibility));
            setLocalFilterActive(false);
        }
        setIsConsult(true);
    };

    return (
        <Tooltip title={t("To consult")}>
            <div
                data-testid={`fidelity-franchise-consult-icon-${row.Id}`}
                role="button"
                tabIndex={0}
                aria-label={t("To consult")}
                onKeyDown={onKeyboardActivate(handleClick)}
            >
                <ConsultSvgIcon
                    className="pointer__clz afa_icn_toConsult"
                    height={35}
                    width={35}
                    style={{
                        cursor: "pointer",
                        position: "relative",
                        bottom: "5px",
                    }}
                    fill="black"
                    onClick={handleClick}
                />
            </div>
        </Tooltip>
    );
}
